'use client';

import { Box, Link, Typography } from '@mui/material';
import type { Author } from '@repo/supergraph/base/types';
import { AuthorTooltipContent } from '../../Authors/TooltipRedesign/TooltipContent';
import { TooltipCSS } from '../../TooltipCSS';

type Props = {
  author: Author;
};

const nameSx = {
  color: 'inherit',
  fontWeight: 700,
  lineHeight: 'normal',
  textDecoration: 'none',
  '&:hover': {
    textDecoration: 'underline',
  },
} as const;

export function BylinePersonNameTrigger({ author }: Props) {
  const avatarUrls = (
    author.avatarUrls?.[0]?.url ? author.avatarUrls : undefined
  ) as Author['avatarUrls'];
  const authorPageHref = author.userPage?.link || author.link;
  const name = authorPageHref ? (
    <Typography component={Link} href={authorPageHref} variant="textSmall" sx={nameSx}>
      {author.name}
    </Typography>
  ) : (
    <Typography component="span" variant="textSmall" sx={nameSx}>
      {author.name}
    </Typography>
  );

  return (
    <TooltipCSS
      disableTouchEvents
      tooltipContent={<AuthorTooltipContent {...author} avatarUrls={avatarUrls} />}
      tooltipProps={{
        sx: {
          border: 'none',
          borderRadius: '1.25rem',
          paddingBottom: 2,
          paddingTop: 3,
          paddingX: 3,
          minWidth: 300,
        },
        'data-testid': 'author-tooltip',
      }}
    >
      <Box component="span">{name}</Box>
    </TooltipCSS>
  );
}
